export const nutl = "nutl"; //New User Tried Login Flag
